import { Navigate, Outlet } from "react-router-dom";
import { Unauthorized } from "../../core/components/Unauthorized";
import { useSlugs } from "../../core/hooks/useSlugs";
import { useAuthorizedLocations } from "../../core/hooks/useAuthorizedLocations";
import { useLastPath } from "../../core/hooks/useLastPath";
import { Module } from "../../ui/components/Module";
import { useEffect, useState } from "react";
import { useAdminDispatch, useAdminSelector } from "../../../stores/AdminStore";
import {
  resetCharityDetails,
  resetPosStateOnLocationChange,
  setCharityDetails,
  setLocationJustifiSubAccountId,
} from "../../../stores/PosSlice";
import { useContextLocation } from "@unleashed-admin/features/core/hooks/useContextLocation";
import { CharityStatus } from "@unleashed-admin/features/pointOfSale/enums/CharityStatus";
import { CharityType } from "@unleashed-admin/features/pointOfSale/enums/CharityType";

export const LocationPicker = () => {
  const lastPath = useLastPath();
  const { brandSlug, locationSlug } = useSlugs();
  const locations = useAuthorizedLocations(brandSlug);
  const [prevLocationSlug, setPrevLocationSlug] = useState<string | null>(null);
  const dispatch = useAdminDispatch();
  const { charityDetails } = useAdminSelector((s) => s.pos);
  const contextLocation = useContextLocation();

  useEffect(() => {
    if (prevLocationSlug !== locationSlug) {
      setPrevLocationSlug(locationSlug);
      dispatch(resetPosStateOnLocationChange());
    }
  }, [dispatch, locationSlug, prevLocationSlug]);

  useEffect(() => {
    if (contextLocation) {
      if (contextLocation.subAccountId) {
        dispatch(setLocationJustifiSubAccountId(contextLocation.subAccountId));
      }

      if (contextLocation.charityDetails && !charityDetails) {
        dispatch(
          setCharityDetails({
            ...contextLocation.charityDetails,
            status: CharityStatus.None,
            type: CharityType.None,
          })
        );
      } else if (!contextLocation.charityDetails) {
        dispatch(resetCharityDetails(true));
      }
    }
  }, [charityDetails, contextLocation, dispatch]);

  if (!locations) {
    return null;
  }

  if (!locations.length) {
    return (
      <Module>
        <Unauthorized />
      </Module>
    );
  }

  if (lastPath === brandSlug) {
    return <Navigate to={`${locations[0].urlSlug}`} replace={true} />;
  }

  return <Outlet />;
};
